var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrivePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1280_120878",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 19,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.79167 2.875H18.2083C19.2625 2.875 20.125 3.7375 20.125 4.79167V18.2083C20.125 19.2625 19.2625 20.125 18.2083 20.125H4.79167C3.7375 20.125 2.875 19.2625 2.875 18.2083V4.79167C2.875 3.7375 3.7375 2.875 4.79167 2.875ZM7.66667 11.0208H6.70833V10.0625H7.66667V11.0208ZM9.10417 11.0208C9.10417 11.8162 8.46208 12.4583 7.66667 12.4583H6.70833V14.375H5.27083V8.625H7.66667C8.46208 8.625 9.10417 9.26708 9.10417 10.0625V11.0208ZM16.2917 10.0625H18.6875V8.625H14.8542V14.375H16.2917V12.4583H17.7292V11.0208H16.2917V10.0625ZM13.8958 12.9375C13.8958 13.7329 13.2537 14.375 12.4583 14.375H10.0625V8.625H12.4583C13.2537 8.625 13.8958 9.26708 13.8958 10.0625V12.9375ZM12.4583 12.9375H11.5V10.0625H12.4583V12.9375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1280_120878)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#6d4096"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivePdf);
export default __webpack_public_path__ + "static/media/drive_pdf.32404ffaf3bfb655afb981c65b0e4851.svg";
export { ForwardRef as ReactComponent };